import type { Persistor } from 'redux-persist'

let persistor: Persistor | undefined

/**
 * Registration rather than a direct import: `clearAllClientState` needs the persistor,
 * and the store needs `clearAllClientState` (via `logoutTeardownMiddleware`), so the
 * direct edge is a cycle. The store owns the persistor and hands it here at startup; the
 * teardown reads it back without importing the store.
 */
export const setPersistor = (next: Persistor): void => {
  persistor = next
}

export const getPersistor = (): Persistor | undefined => persistor
